// extracted by mini-css-extract-plugin
module.exports = {"wrap":"EditDetails_wrap__3g_TD"};